import { watchDeleteSalesRep } from './deletesSalesRep';
import { watchFetchSalesRepCallGoals } from './fetchSalesRepCallGoals';
import { watchFetchSalesReps } from './fetchSalesReps';
import { watchSaveSalesRep } from './saveSalesRep';
import { watchSaveSalesRepCallGoals } from './saveSalesRepCallGoals';

export const salesRepSagas = [
  watchFetchSalesReps(),
  watchSaveSalesRep(),
  watchDeleteSalesRep(),
  watchFetchSalesRepCallGoals(),
  watchSaveSalesRepCallGoals()
];
